import { logout } from 'actions'
import jwt from 'jwt-decode'
import { useDispatch, useSelector } from 'react-redux'
import { Navigate, Route } from 'react-router-dom'

export const ProtectedRoute: React.FC<{ children: JSX.Element }> = ({ children }) => {
  const dispatch = useDispatch()
  const auth = useSelector((state: any) => state.auth)
  let success = false

  try {
    const payload: any = jwt(auth.token)
    if (payload.exp * 1000 > Date.now()) {
      success = true
    } else {
      dispatch(logout())
    }
  } catch {}

  try {
    if (auth.profile.temparary) {
      dispatch(logout())
      success = false
    }
  } catch {}

  if (success) return children
  return <Route element={<Navigate to="/home" replace />} />
}
